import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Header from "../../components/Header";
import { Button, Icon } from "semantic-ui-react";
import * as AppActions from "../../actions";
import TaskListItem from "../../components/TaskListItem";
import TaskEditor from "../../components/TaskEditor";
import "./style.css";

class TasksContainer extends Component {

  state = {
    taskEditModal: false,
    taskEdit: null
  }

  componentDidMount() {
    this.props.actions.getTaskList();
  }

  createTask = e => {
    this.setState({ taskEditModal: true })
  }

  onEdit = task => {
    this.setState({
      taskEditModal: true,
      taskEdit: task
    })
  }

  onCloseEditor = () => {
    this.setState({
      taskEditModal: false,
      taskEdit: null
    })
  }

  renderTaskEditor = () => (<div>
    {this.state.taskEditModal &&
      <TaskEditor
        onClose={this.onCloseEditor}
        task={this.state.taskEdit}
      />}
  </div>);


  render() {
    const y = window.innerHeight - 50 + "px";
    const { actions } = this.props;
    const { tasks } = this.props;

    return (
      <div>
        {this.renderTaskEditor()}
        <Header
          formTitle={"Tasks"}
          setSidebarVisibility={actions.setSidebarVisibility}
        ></Header>
        <div className="tasks" style={{
          height: y,
        }}>
          {tasks.data && tasks.data.map(task => (<TaskListItem
            task={task} onEdit={this.onEdit} key={task.task_id}>
          </TaskListItem>))}
          <div >
            <Button
              onClick={() => this.onEdit(null)}
              className="ui button"
              ref="UnToggle"
              role="button"
              active
            >
              Create
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

TasksContainer.propTypes = {};

const mapStateToProps = state => ({
  isConnected: state.informedWebApp.isConnected,
  storeColour: state.informedWebApp.storeColour,
  passwordChanged: state.informedWebApp.passwordChanged,
  isLoading: state.informedWebApp.isLoading,
  username: state.informedWebApp.username,
  environment:
    state.informedWebApp.api === "https://www.in-formed.co.uk/api.php"
      ? "Live"
      : "Test",
  application_version: state.informedWebApp.application_version,
  tasks: state.tasks,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TasksContainer)
);



// WEBPACK FOOTER //
// ./src/containers/TasksContainer/index.js